module.exports = __webpack_public_path__ + "img/DSC_0046.3bf45e26.jpeg";